import { NetworkError, ValidationError, errorFromResponse } from "./errors.js";

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
async function request(path, method, body, { signal } = {}) {
  let response;
  try {
    response = await fetch(`/api/projects/risk-register${path}`, {
      method, credentials: "include", headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body), signal,
    });
  } catch (error) {
    if (error.name === "AbortError") throw error;
    throw new NetworkError(`Network error: ${error.message}`);
  }
  if (!response.ok) {
    const error = await errorFromResponse(response);
    error.status = response.status;
    throw error;
  }
  return response.json();
}
export function getRiskRegister(projectIds, options) {
  if (!Array.isArray(projectIds) || projectIds.some(id => !UUID.test(id)))
    throw new ValidationError("projectIds must contain project UUIDs.");
  return request("/read", "POST", { projectIds: [...new Set(projectIds)] }, options);
}
export function saveRiskRegister(projectId, payload, options) {
  if (!UUID.test(projectId)) throw new ValidationError("A valid project UUID is required.");
  return request(`/${projectId}`, "PUT", payload, options);
}
